<template>
  <div class="flex flex-wrap gap-3 py-3">
    <div
      v-for="(filename, idx) in symbols.slice(0, 5)"
      :key="idx"
      class="w-16 md:w-24"
    >
      <div class="flex flex-col items-start">
        <FunctionIcon :icon="filename" class="!h-14 !w-auto md:!h-20" />
        <div
          v-if="iconTexts[countryCode]?.[filename]"
          class="break-words text-center text-sm leading-3"
        >
          {{ iconTexts[countryCode]?.[filename] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import iconTexts from './ProductFunctionIconsTexts'
import { useCurrentShop } from '#storefront/composables'
import { resolveCountryCode } from '~/config/functionIcons'

defineProps({
  symbols: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
})
const currentShop = useCurrentShop()
const countryCode = resolveCountryCode(currentShop.value.locale)
</script>
